import { useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import Copy from 'components/Copy';
import { DataCellProps } from '../types';

export const TenantIdCell = ({ _customRowProps, tenant }: DataCellProps) => {
  const [hovered, setHovered] = useState(false);
  const value = tenant.id?.toString() ?? '';

  return (
    <Box
      display="flex"
      alignItems="center"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Box mr={1}>{value}</Box>
      {value ? (
        <Box visibility={hovered ? 'visible' : 'hidden'}>
          <Tooltip title="Copy tenant ID">
            <span>
              <Copy textToCopy={value} size="small" />
            </span>
          </Tooltip>
        </Box>
      ) : null}
    </Box>
  );
};
